import { render, staticRenderFns } from "./DrawingHighlightsSimpleList.vue?vue&type=template&id=edbf96ca&scoped=true"
import script from "./DrawingHighlightsSimpleList.vue?vue&type=script&lang=js"
export * from "./DrawingHighlightsSimpleList.vue?vue&type=script&lang=js"
import style0 from "./DrawingHighlightsSimpleList.vue?vue&type=style&index=0&id=edbf96ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbf96ca",
  null
  
)

export default component.exports